export default __webpack_public_path__ + "static/media/help-index.5be978eb.png";